import { alpha, type Theme } from "@mui/material/styles";
import { HOLIDAY_GROUPS } from "@/theme/tokens";

/** The light brand tint behind a holiday's day header, applied or not. */
export const holidayHeaderTint = (theme: Theme): string => alpha(theme.palette.primary.main, HOLIDAY_GROUPS.SCHEDULE_HEADER_TINT_ALPHA);

/** The brand wash on an applied holiday's shift cells: its shifts are on the schedule. */
export const holidayCellTint = (theme: Theme): string => alpha(theme.palette.primary.main, HOLIDAY_GROUPS.SCHEDULE_CELL_TINT_ALPHA);

/**
 * An applied holiday's wash on one day cell of the Gaps week, as a background image: it layers over the cell's own
 * fill (white, hover, highlight) and under its text, so the column lines up with the cells by construction.
 */
export const holidayColumnWashSx = (theme: Theme) => {
	const wash = holidayCellTint(theme);
	return { backgroundImage: `linear-gradient(${wash}, ${wash})` };
};
